<template>
	<div class="edit-verify" v-loading="pageLoading">
		<div class="title">
			<el-alert type="warning" effect="light" :closable="false">
				<div slot="title">
					当前演出：<el-link @click="view" target="_blank"
						type="primary">{{activityName}}</el-link>（演出ID：{{activityId}}）
				</div>
			</el-alert>
		</div>
		<template v-if="detailData">
			<div class="part-title">演出展示信息</div>
			<div>APP展示设置：
				<span v-if="detailData.appHideType == 0" class="MR20">正常展示</span>
				<span v-if="detailData.appHideType == 1" class="MR20">列表隐藏</span>
				<span v-if="detailData.appHideType == 2" class="MR20">列表和详情页均隐藏</span>
				WAPCN 展示设置：
				<span v-if="detailData.wapHideType == 0" class="MR20">正常展示</span>
				<span v-if="detailData.wapHideType == 1" class="MR20">列表隐藏</span>
				<span v-if="detailData.wapHideType == 2" class="MR20">列表和详情页均隐藏</span>
			</div>
		</template>
		<template v-if="detailData && detailData.thirdNames">
			<div class="MT20">
				外部销售：
				<span v-for="(i,idx) in detailData.thirdNames" :key="idx">
					{{i}}
				</span>
			</div>
		</template>
		<template v-if="detailData && detailData.newChannelNames && detailData.newChannelNames.length">
			<div class="MT20 new-channel-wrap">
				<span class="new-channel-label">新增渠道：</span>
				<el-tag v-for="(i,idx) in detailData.newChannelNames" :key="idx" type="success" size="small" class="new-channel-tag">
					{{i}}
				</el-tag>
			</div>
		</template>
		<template v-if="detailData && detailData.damaiPoster">
			<div class="MT20">
				大麦海报：
				<el-image class="MT10" :src="detailData.damaiPoster | coverImage(120, 160)" fit="cover"
					:preview-src-list="[detailData.damaiPoster]" style="width: 120px; height: 160px;"></el-image>
			</div>
		</template>
		<!-- 基本信息 -->
		<template v-if="sourceActivityInfoVO">
			<div class="part-title">基本信息差异对比</div>
			<el-row :gutter="20" type="flex" justify="space-between">
				<el-col :span="11">
					<el-card class="box-card">
						<BaseInfo :baseData="sourceActivityInfoVO" :newContent="newContent" :oldContent="oldContent"
							@siteBind="siteBind()" :siteValue.sync="siteValue" :activityId="activityId"></BaseInfo>
					</el-card>
				</el-col>
				<div class="separate-box">
					<div>
						<i class="el-icon-arrow-right icon"></i>
					</div>
				</div>
				<el-col :span="11">
					<el-card class="box-card">
						<BaseInfo v-if="currentActivityInfoVO" :baseData="currentActivityInfoVO"
							:newContent="newContent" :oldContent="oldContent" @siteBind="siteBind()"
							:siteValue.sync="siteValue" :current="true" :status="detailData && detailData.status"
							:activityId="activityId"></BaseInfo>
					</el-card>
				</el-col>
			</el-row>
		</template>
		<!-- 售票信息 -->
		<template v-if="sourceSessionVos">
			<div class="part-title">场次售票信息差异对比</div>
			<el-row :gutter="20" type="flex" justify="space-between" align="middle">
				<el-col :span="11">
					<el-card class="box-card">
						<ActivityUpdate :activityData.sync="sourceSessionVos" />
					</el-card>
				</el-col>
				<div class="separate-box">
					<div>
						<i class="el-icon-arrow-right icon"></i>
					</div>
				</div>
				<el-col :span="11">
					<el-card class="box-card">
						<ActivityUpdate :activityData.sync="currentSessionVos" :current="true"
							:status="detailData && detailData.status" />
					</el-card>
				</el-col>
			</el-row>
		</template>
		<template v-if="currentSessionRefundRules || sourceSessionRefundRules">
			<div class="part-title">场次退票规则差异对比</div>
			<el-row :gutter="20" type="flex" justify="space-between" align="middle">
				<el-col :span="11">
					<el-card class="box-card" style="vertical-align: middle;">
						<span class="rules">退票规则：</span>
						<span style="margin-right: 10px;">{{ detailData.sourceSessionRefundRules.refundRuleType == 1 ?
							'不支持退票' : detailData.sourceSessionRefundRules.refundRuleType == 2 ? '支持退，整场演出进行设置' : '支持退，各个场次进行设置' }}</span>
						<el-link type="text" @click="$refs.refundticket.show(detailData)" class="color-success"
							style="margin-top: -5px;">点击查看详情<i class="el-icon-d-arrow-right icon"></i> </el-link>
					</el-card>
				</el-col>
				<div class="separate-box">
					<div>
						<i class="el-icon-arrow-right icon"></i>
					</div>
				</div>
				<el-col :span="11">
					<el-card class="box-card" style="vertical-align: middle;">
						<span class="rules">退票规则：</span>
						<span style="margin-right: 10px;">{{ detailData.currentSessionRefundRules.refundRuleType === 1 ?
							'不支持退票' : detailData.currentSessionRefundRules.refundRuleType === 2 ? '支持退，整场演出进行设置' : '支持退，各个场次进行设置' }}</span>
						<el-link type="text" @click="$refs.refundticket.show(detailData)" class="color-success"
							style="margin-top: -5px;">点击查看详情<i class="el-icon-d-arrow-right icon"></i></el-link>
					</el-card>
				</el-col>
			</el-row>
		</template>
		<!-- 新增场次 -->
		<template v-if="addSessions">
			<div class="part-title">新增场次</div>
			<el-row :gutter="20" type="flex" justify="space-between" align="middle">
				<el-col :span="11">
					<el-card class="box-card">
						<ActivityUpdate :activityData.sync="addSessions" :current="true"
							:status="detailData && detailData.status" />
					</el-card>
				</el-col>
			</el-row>
		</template>
		<!-- 添加票品 -->
		<template v-if="addActivitySessionTicketPrices">
			<div class="part-title">添加票品</div>
			<el-row :gutter="20" type="flex" justify="space-between" align="middle">
				<el-col :span="11">
					<el-card class="box-card">
						<div v-for="(i,idx) in addActivitySessionTicketPrices" :key="idx">
							<div><span :class="['session-title', !idx ?'type1': '']">场次名称: </span>{{i.sessionName}}
							</div>
							<AddTicket :ticketPrices="i.addSessionTicketPrices" />
						</div>
					</el-card>
				</el-col>
			</el-row>
		</template>
		<!-- 新增通票 -->
		<template v-if="addThroughTicketList">
			<div class="part-title">新增通票</div>
			<el-row :gutter="20" type="flex" justify="space-between" align="middle">
				<el-col :span="11">
					<el-card class="box-card">
						<ThroughTicket :tickets="addThroughTicketList" :sessions="sessions" />
					</el-card>
				</el-col>
			</el-row>
		</template>
		<!-- 通票信息差异对比（编辑通票 before/after，元素仅含变更字段） -->
		<template v-if="sourceThroughTicketList">
			<div class="part-title">通票信息差异对比</div>
			<el-row :gutter="20" type="flex" justify="space-between" align="middle">
				<el-col :span="11">
					<el-card class="box-card">
						<ThroughTicket :tickets="sourceThroughTicketList" :sessions="sessions" />
					</el-card>
				</el-col>
				<div class="separate-box">
					<div>
						<i class="el-icon-arrow-right icon"></i>
					</div>
				</div>
				<el-col :span="11">
					<el-card class="box-card">
						<ThroughTicket :tickets="currentThroughTicketList" :sessions="sessions"
							:compare-tickets="sourceThroughTicketList" />
					</el-card>
				</el-col>
			</el-row>
		</template>
		<template v-if="detailData && detailData.qrCodeCheck&& detailData.qrCodeCheck.containsQRCode"> 
			<el-card class="MT20">
				<span>图片检测</span>
				<span class="color-danger ML10">（以下为系统自动检测到的包含二维码或引流，建议执行拒绝操作，或者审核通过后在管理后台修改）</span>
				<table class="info-table MT20" style="width:100%">
					<tr>
						<th>位置</th>
						<th>检测类似</th>
						<th>图片</th>
					</tr>
					<tr v-for="(item, index) in detailData.qrCodeCheck.qrCodeList" :key="index">
						<td>
							<span v-if="item.sourceType === 'poster'">海报</span>
							<span v-else-if="item.sourceType === 'document'">演出详情图片</span>
						</td>
						<td><span v-if="detailData.qrCodeCheck.containsQRCode">包含二维码</span></td>
						<td>
							<el-image :src="item.sourceImage | coverImage(60,60)" fit="cover"
								:preview-src-list="[item.sourceImage]"></el-image>
						</td>
					</tr>
				</table>
			</el-card>
		</template>
		<!-- 审核信息 -->
		<template v-if="detailData">
			<div class="part-title">审核信息</div>
			<el-card class="box-card">
				<div><span class="color-info">提交审核时间: </span>{{detailData.createTime}}</div>
				<div class="MT10"><span class="color-info">审核状态: </span>{{status.get(detailData.status)}}</div>
				<div v-if="detailData.auditUserName" class="MT10"><span class="color-info">审核人:
					</span>{{detailData.auditUserName}}</div>
				<div v-if="detailData.auditTime" class="MT10"><span class="color-info">审核时间:
					</span>{{detailData.auditTime}}</div>
				<div v-if="detailData.remark" class="MT10"><span class="color-info">备注: </span>{{detailData.remark}}
				</div>
			</el-card>
		</template>
		<div class="btn-box MT10">
			<el-button @click="goBack" size="medium">返 回</el-button>
			<template v-if="detailData && detailData.status == 1">
				<el-button type="success" @click="auditCheck(1)" size="medium"
					v-if="$utils.have('/activity/updateAudit/approved')">通 过</el-button>
				<el-button type="danger" @click="rejectedDialogVisible = true;" size="medium"
					v-if="$utils.have('/activity/updateAudit/auditReject')">拒 绝</el-button>
				<el-button type="success" @click="auditCheck(0)" size="medium"
					v-if="$utils.have('/activity/updateAudit/approved')">免敏感词检测通过</el-button>
			</template>
			<el-button @click="view" size="medium">查看演出详情</el-button>
		</div>
		<!-- 绑定正式场地 -->
		<!-- <el-drawer title="绑定正式场地" :visible.sync="siteBindVisible" size="auto" :destroy-on-close="true" append-to-body>
			<div class="drawer-content">
				<el-alert type="warning" :closable="false">
					<div>
						用户生成了自定义场地：{{currentActivityInfoVO && currentActivityInfoVO.customSite && JSON.parse(currentActivityInfoVO.customSite).name}}
					</div>
					<div>请绑定一个对应的正式场地</div>
					<div>如果系统中没有该场地，请先<el-button size="mini" type="text" @click="addSite">创建正式场地</el-button>，然后再来绑定
					</div>
				</el-alert>
				<el-form :model="site" ref="siteForm" label-position="top" class="MT20">
					<el-form-item prop="value" :rules="[{required: true, message: '请选择演出场地'}]">
						<span slot="label">绑定正式场地: </span>
						<el-select v-model="site.value" filterable remote placeholder="请输入演出场地"
							:remote-method="searchSite" :loading="userLoading" size="medium" value-key="id">
							<el-option v-for="item in siteList" :key="item.id" :label="item.name" :value="item">
							</el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</div>
			<div class="drawer-footer">
				<el-button @click="siteBindVisible = false" size="medium">取 消</el-button>
				<el-button type="primary" @click="siteSubmit" size="medium">确 定</el-button>
			</div>
		</el-drawer> -->
		<!-- 通过弹窗 -->
		<el-drawer title="是否确认通过审核？" :visible.sync="fulfilledDialogVisible" size="auto" :destroy-on-close="true"
			append-to-body>
			<div class="drawer-content">
				<el-alert
					v-if="detailData && (detailData.isPerformerChange == 1 || siteId != '' || detailData.isUpdateSite == 1 || detailData.isUpdateSessionTime == 1)"
					title="请注意" type="warning" :closable="false">
					<ul>
						<!-- <li v-if="detailData.isAddSite == 1">用户新增了场地，通过审核后，还需手动绑定正式场地</li> -->
						<!-- <li v-if="detailData.isUpdateSite == 1">用户修改了场地，通过审核后，请酌情考虑是否需要对用户发送变更通知</li> -->
						<li v-if="siteId != '' || detailData.isUpdateSite == 1">此次提交将会变动<span
								class="color-danger">演出场地</span>，通过审核后，请酌情考来是否需要对用户发送变更通知</li>
						<li v-if="detailData.isPerformerChange == 1">此次提交将会变动<span
								class="color-danger">正式艺人阵容</span>，通过审核后，请酌情考虑是否需要对用户发送变更通知</li>
						<li v-if="detailData.isUpdateSessionTime == 1">此次提交将会变动<span
								class="color-danger">演出时间</span>，通过审核后，请酌情考虑是否需要对用户发送变更通知</li>
						<li v-if="detailData.isGuestChange == 1">此次提交将会变动<span
								class="color-danger">正式嘉宾阵容</span>，通过审核后，请酌情考虑是否需要对用户发送变更通知</li>
					</ul>
				</el-alert>
				<el-form class="MT20">
					<el-form-item label="审核备注:">
						<el-input type="textarea" v-model="fulfilledRemark" placeholder="请输入审核备注" maxlength="100"
							show-word-limit></el-input>
					</el-form-item>
					<el-form-item label="场地特殊审核备注:" v-if="detailData && detailData.siteAuditRemark">
						{{detailData.siteAuditRemark}}
					</el-form-item>
				</el-form>
			</div>
			<div class="drawer-footer">
				<el-button @click="fulfilledDialogVisible = false" size="medium">取 消</el-button>
				<el-button type="primary" @click="submit('fulfilled')" :loading="fulfilledLoading" size="medium">通
					过</el-button>
			</div>
		</el-drawer>

		<!-- 免敏感词检测通过弹窗 -->
		<el-drawer title="是否确认免敏感词检测通过审核？" :visible.sync="nocheckedDialogVisible" size="auto" :destroy-on-close="true"
			append-to-body>
			<div class="drawer-content">
				<el-alert
					v-if="detailData && (detailData.isPerformerChange == 1 || siteId != '' || detailData.isUpdateSite == 1 || detailData.isUpdateSessionTime == 1)"
					title="请注意" type="warning" :closable="false">
					<ul>
						<!-- <li v-if="detailData.isAddSite == 1">用户新增了场地，通过审核后，还需手动绑定正式场地</li> -->
						<!-- <li v-if="detailData.isUpdateSite == 1">用户修改了场地，通过审核后，请酌情考虑是否需要对用户发送变更通知</li> -->
						<li v-if="siteId != '' || detailData.isUpdateSite == 1">此次提交将会变动<span
								class="color-danger">演出场地</span>，通过审核后，请酌情考来是否需要对用户发送变更通知</li>
						<li v-if="detailData.isPerformerChange == 1">此次提交将会变动<span
								class="color-danger">正式艺人阵容</span>，通过审核后，请酌情考虑是否需要对用户发送变更通知</li>
						<li v-if="detailData.isUpdateSessionTime == 1">此次提交将会变动<span
								class="color-danger">演出时间</span>，通过审核后，请酌情考虑是否需要对用户发送变更通知</li>
						<li v-if="detailData.isGuestChange == 1">此次提交将会变动<span
								class="color-danger">正式嘉宾阵容</span>，通过审核后，请酌情考虑是否需要对用户发送变更通知</li>
					</ul>
				</el-alert>
				<el-form class="MT20">
					<el-form-item label="审核备注:">
						<el-input type="textarea" v-model="nocheckedRemark" placeholder="请输入审核备注" maxlength="100"
							show-word-limit></el-input>
					</el-form-item>
					<el-form-item label="场地特殊审核备注:" v-if="detailData && detailData.siteAuditRemark">
						{{detailData.siteAuditRemark}}
						<!-- <el-input v-model="siteAuditRemark" type="textarea" :rows="4" maxlength="200" show-word-limit></el-input> -->
					</el-form-item>
				</el-form>
			</div>
			<div class="drawer-footer">
				<el-button @click="nocheckedDialogVisible = false" size="medium">取 消</el-button>
				<el-button type="primary" @click="submit('nochecked')" :loading="nocheckedLoading" size="medium">通
					过</el-button>
			</div>
		</el-drawer>


		<!-- 拒绝弹窗 -->
		<el-drawer title="是否确认拒绝审核？" :visible.sync="rejectedDialogVisible" size="auto" :destroy-on-close="true"
			append-to-body>
			<div class="drawer-content">
				<!-- <el-alert v-if="detailData && (detailData.isPerformerChange == 1 || detailData.isAddSite == 1 || detailData.isUpdateSite == 1 || detailData.isUpdateSessionTime == 1)" title="请注意" type="warning" :closable="false">
                    <ul>
                        <li v-if="detailData.isPerformerChange == 1">有场次艺人阵容发生了变动，通过审核后，还需手动绑定正式艺人</li>
                        <li v-if="detailData.isAddSite == 1">用户新增了场地，通过审核后，还需手动绑定正式场地</li>
                        <li v-if="detailData.isUpdateSite == 1">用户修改了场地，通过审核后，请酌情考虑是否需要对用户发送变更通知</li>
                        <li v-if="detailData.isUpdateSessionTime == 1">有场次演出时间发生了变动，通过审核后，请酌情考虑是否需要对用户发送变更通知</li>
                    </ul>
                </el-alert> -->
				<el-form class="MT20">
					<el-form-item label="审核备注:">
						<el-input type="textarea" v-model="rejectedRemark" placeholder="请输入审核备注"
							maxlength="100"></el-input>
					</el-form-item>
					<el-form-item label="场地特殊审核备注:" v-if="detailData && detailData.siteAuditRemark">
						{{detailData.siteAuditRemark}}
						<!-- <el-input v-model="siteAuditRemark" type="textarea" :rows="4" maxlength="200" show-word-limit></el-input> -->
					</el-form-item>
				</el-form>
			</div>
			<div class="drawer-footer">
				<el-button @click="rejectedDialogVisible = false" size="medium">取 消</el-button>
				<el-button type="danger" @click="submit('rejected')" :loading="rejectedLoading" size="medium">拒
					绝</el-button>
			</div>
		</el-drawer>
		<!-- <H5Preview ref="H5Preview"></H5Preview> -->
		<!-- 新建场地 -->
		<site-add ref="siteAdd" @onUpdate="updateSite" @bindSite="siteSubmit"></site-add>
		<refund-ticket ref="refundticket"></refund-ticket>
	</div>
</template>

<script>
	import {
		BaseInfo,
		ActivityUpdate,
		AddTicket,
		ThroughTicket
	} from './components'
	// import H5Preview from '@/components/H5Preview';
	// import {
	// 	fetchUser
	// } from '@/assets/js/commonApi';
	import SiteAdd from '@/components/SiteAdd';
	import RefundTicket from './components/RefundTicket';
	export default {
		components: {
			BaseInfo,
			ActivityUpdate,
			AddTicket,
			ThroughTicket,
			SiteAdd,
			RefundTicket
			// H5Preview
		},
		props: {
			recordId: {
				type: [Number, String],
				default: null
			}
		},
		data() {
			return {
				detailData: null,
				pageLoading: false,

				activityName: '',
				activityId: '',
				// 修改基本信息
				sourceActivityInfoVO: null,
				currentActivityInfoVO: null,
				// 修改场次票品信息
				sourceSessionVos: null,
				currentSessionVos: null,
				// 新增场次
				addSessions: null,
				// 新增票品
				addActivitySessionTicketPrices: null,

				//场次退票规则差异对比
				currentSessionRefundRules: null,
				sourceSessionRefundRules: null,
				
				// 演出简介
				newContent: '',
				oldContent: '',

				fulfilledDialogVisible: false,
				nocheckedDialogVisible: false,
				fulfilledRemark: '',
				nocheckedRemark: '',
				fulfilledLoading: false,
				nocheckedLoading: false,

				rejectedDialogVisible: false,
				rejectedRemark: '',
				rejectedLoading: false,


				redirect: this.$route.query.redirect || "/activityManage/editVerify/list",

				//绑定场地相关
				// siteBindVisible: false,
				site: {
					value: null
				},
				// siteList: [], //场地集合
				// userLoading: false,
				siteId: '',
				siteValue: null,

				//场次名列表（通票 sessionIds 翻译兜底）
				sessionNames: []
			}
		},
		computed: {
			// siteLink(){
			//     return `/pages/activity/detail/detail?id=${this.activityId}`
			// },
			status() {
			return new Map([
				[1, '待审核'],
				[2, '已通过'],
				[3, '已拒绝'],
				[4, '已撤销'],
			])
		},
		// 新增通票（完整数据，无变更为 null）
		addThroughTicketList() {
			return this.detailData && this.detailData.addThroughTickets || null;
		},
		// 编辑通票 before（仅变更字段，无变更为 null）
		sourceThroughTicketList() {
			return this.detailData && this.detailData.sourceThroughTickets || null;
		},
		// 编辑通票 after（与 before 按下标一一对应，兜底空数组）
		currentThroughTicketList() {
			return this.detailData && this.detailData.currentThroughTickets || [];
		},
		// 详情内场次集合（合并各场次数据并去重，用于通票 sessionIds 翻译为场次名+开演时间）
		sessions() {
			if (!this.detailData) return [];
			const arr = [];
			const push = list => (list || []).forEach(s => {
				if (s && !arr.includes(s)) arr.push(s);
			});
			push(this.detailData.sessions);
			push(this.detailData.sourceSessionVos);
			push(this.detailData.currentSessionVos);
			push(this.detailData.addSessions);
			push(this.sessionNames); // 兜底：未变更场次不在对比数据中，用场次名接口补全
			return arr;
		}
		},
		created() {
			this.getDetail();
		},
		methods: {
			//获取场次名列表（通票 sessionIds 翻译兜底）
			getSessionNames(activityId) {
				this.$request({
					url: '/activity/sessionNames',
					method: "POST",
					params: {activityId}
				})
					.then((res) => {
						const {state, result} = res.data;
						if (state == 1) {
							this.sessionNames = result || [];
						}
					});
			},
			//获取详情
			getDetail() {
				this.pageLoading = true;
				this.$request({
						url: "/activity/updateAudit/detail",
						method: "POST",
						params: {
							recordId: this.recordId
						}
					})
					.then((res) => {
						const {
							state,
							msg,
							result
						} = res.data;
						if (state == 1 && result) {
								const {
									title,
									activityId,
									sourceActivityInfoVO,
									currentActivityInfoVO,
									sourceSessionVos,
									currentSessionVos,
									addSessions,
									addActivitySessionTicketPrices,
									currentSessionRefundRules,
									sourceSessionRefundRules
								} = result;
								this.detailData = result;
								this.activityName = title;
								this.activityId = activityId;

								// 存在通票变更时，兜底获取场次名列表（detail 内变更场次可能不完整，未变更场次不在对比数据中）
								if (result.addThroughTickets || result.sourceThroughTickets) {
									this.getSessionNames(activityId);
								}

							this.sourceActivityInfoVO = sourceActivityInfoVO;
							this.currentActivityInfoVO = currentActivityInfoVO;

							this.sourceSessionVos = sourceSessionVos;
							this.currentSessionVos = currentSessionVos;
							
							this.addSessions = addSessions;
							this.addActivitySessionTicketPrices = addActivitySessionTicketPrices;
							
							this.currentSessionRefundRules = currentSessionRefundRules
							this.sourceSessionRefundRules = sourceSessionRefundRules

							this.sourceSessionVos?.map(v => {
								if (v.customPerformer) {
									if (v.customPerformer.includes('[{')) {
										v.customPerformer = JSON.parse(v.customPerformer);
									} else {
										const performers = v.customPerformer.split(',');
										v.customPerformer = performers.map(v => ({
											name: v
										}));
									}
								}
								if (v.customGuest) {
									if (v.customGuest.includes('[{')) {
										v.customGuest = JSON.parse(v.customGuest);
									} else {
										const guests = v.customGuest.split(',');
										v.customGuest = guests.map(v => ({
											name: v
										}));
									}
								}
							})

							this.currentSessionVos?.map(v => {
								if(v.customPerformer){
									if(v.customPerformer.includes('[{')){
										v.customPerformer = JSON.parse(v.customPerformer);
									}else{
										const performers = v.customPerformer.split(',');
										v.customPerformer = performers.map(v => ({
											name: v
										}));
									}
								}
								if(v.customGuest){
									if(v.customGuest.includes('[{')){
										v.customGuest = JSON.parse(v.customGuest);
									}else{
										const guests = v.customGuest.split(',');
										v.customGuest = guests.map(v => ({
											name: v
										}));
									}
								}
							})

							this.addSessions?.map(v => {
								if (v.customPerformer) {
									if (v.customPerformer.includes('[{')) {
										v.customPerformer = JSON.parse(v.customPerformer);
									} else {
										const performers = v.customPerformer.split(',');
										v.customPerformer = performers.map(v => ({
											name: v
										}));
									}
								}
								if (v.customGuest) {
									if (v.customGuest.includes('[{')) {
										v.customGuest = JSON.parse(v.customGuest);
									} else {
										const guests = v.customGuest.split(',');
										v.customGuest = guests.map(v => ({
											name: v
										}));
									}
								}
							})

							if (sourceActivityInfoVO) {
								this.newContent = currentActivityInfoVO.document;
								this.oldContent = sourceActivityInfoVO.document;
							}
						} else {
							this.$message.error(msg || "请求失败");
						}
					})
					.finally(() => {
						this.pageLoading = false;
					});
			},
			//审核
			submit(type) {

				const performerList = []

				if (this.currentSessionVos) {
					this.currentSessionVos.map(v => {
						if (v.customPerformer && v.performerList) {
							performerList.push({
								idStr: v.idStr,
								performers: v.performerList.map(v => v.id)
							})
						}
					})
				}
				const guestList = []
				if (this.currentSessionVos) {
					this.currentSessionVos.map(v => {
						if (v.customGuest && v.performerList2) {
							guestList.push({
								idStr: v.idStr,
								performers: v.performerList2.map(v => v.id)
							})
						}
					})
				}

				if (this.addSessions) {
					this.addSessions.map(v => {
						if (v.customPerformer && v.performerList) {
							performerList.push({
								idStr: v.idStr,
								performers: v.performerList.map(v => v.id)
							})
						}
					})
				}


				const data = {
					recordId: this.recordId,
					remark: this[`${type}Remark`],
					siteId: this.siteId || '',
					performerList: performerList,
					guestList: guestList,
					isCheckWord: type === 'nochecked' ? 0 : 1
				};

				// const url = type == 'fulfilled' ? '/activity/updateAudit/approve' : '/activity/updateAudit/auditReject'
				const url = type == 'rejected' ? '/activity/updateAudit/auditReject' : '/activity/updateAudit/approved'


				if (type == "rejected" && !data.remark) {
					return this.$message.error('拒绝通过时，请在备注填写拒绝原由');
				}
				this[`${type}Loading`] = true;

				// console.log(data)
				// return

				this.$request({
						url,
						method: "POST",
						// params: data,
						data: {
							...data
						}
					})
					.then((res) => {
						const {
							state,
							msg
						} = res.data;
						if (state == 1) {
							this.$message.success(msg || "操作成功");
							this[`${type}DialogVisible`] = false;
							this.getDetail();
						} else {
							this.$message.error(msg || "请求失败");
						}
					})
					.finally(() => {
						this[`${type}Loading`] = false;
					});
			},
			goBack() {
				this.$router.push({
					path: this.redirect,
				});
			},
			view() {
				window.open(`/activityManage/activity/edit/baseInfo/${this.activityId}`)
			},


			//审核验证,isCheckWord(是否检测敏感词 1:检测 0:不检测)
			auditCheck(isCheckWord) {
				var _isCheckWord = isCheckWord

				const _customSite = this.currentActivityInfoVO && this.currentActivityInfoVO.customSite || null;

				let performerFlag = true;
				if (this.currentSessionVos) {
					this.currentSessionVos.map(v => {
						if (v.customPerformer && !v.performerList) {
							performerFlag = false;
						}
					})
				}
				if (this.addSessions) {
					this.addSessions.map(v => {
						if (v.customPerformer && !v.performerList) {
							performerFlag = false;
						}
					})
				}


				if (_customSite && !this.siteId) {
					this.siteBind();
				} else if (!performerFlag) {
					this.$confirm('用户编辑了自定义艺人，是否需要处理', '提示', {
						type: 'warning',
						center: true,
						confirmButtonText: '进行处理',
						cancelButtonText: '已经处理，继续审核',
						closeOnClickModal: false,
						showClose: false
					}).then(() => {

					}).catch(() => {
						if (_isCheckWord == 1) {
							this.fulfilledDialogVisible = true;
						} else {
							this.nocheckedDialogVisible = true;
						}

					})
				} else {
					if (_isCheckWord == 1) {
						this.fulfilledDialogVisible = true;
					} else {
						this.nocheckedDialogVisible = true;
					}
				}
			},
			// 搜索场地
			// async searchSite(query) {
			// 	if (query !== "") {
			// 		this.userLoading = true;
			// 		const res = await fetchUser({
			// 			queryValue: query,
			// 			userType: 3,
			// 		}).finally(() => {
			// 			this.userLoading = false;
			// 		});

			// 		const {
			// 			state,
			// 			result
			// 		} = res.data;

			// 		if (state == 1 && result) {
			// 			this.siteList = result;
			// 		}
			// 	}
			// },
			//绑定场地
			siteBind() {
				this.site = {
					value: null
				}
				// this.$refs["siteForm"] && this.$refs["siteForm"].clearValidate();
				// this.siteBindVisible = true;
				this.addSite();
			},
			siteSubmit(data) {
				this.siteId = data.id;
				// this.fulfilledDialogVisible = true;
				this.siteValue = {
					...data
				};
				// this.siteBindVisible = false;
				// this.auditCheck();
			},
			//添加场地
			addSite() {
				const _customSite = this.currentActivityInfoVO && JSON.parse(this.currentActivityInfoVO.customSite) || null
				this.$refs.siteAdd.show(_customSite);
				// this.siteBindVisible = false;
			},
			updateSite(data) {
				this.siteId = data.id;
				this.site.value = {
					...data
				};
				this.siteValue = {
					...this.site.value
				};
				// this.fulfilledDialogVisible = true;
				// this.auditCheck();
			},
		}
	}
</script>

<style lang="scss" scoped>
	.edit-verify {
		.title {
			margin: -20px -20px 0 -20px;

			.el-alert {
				border-radius: 0;

				::v-deep .el-alert__title {
					font-size: 14px;
				}

			}

			.el-link {
				vertical-align: middle;
			}
		}

		.part-title {
			padding: 20px 0;
		}

		.separate-box {
			width: 30px;
			display: flex;
			justify-content: center;
			align-items: center;

			div {
				width: 30px;
				height: 30px;
				display: flex;
				justify-content: center;
				align-items: center;
				border-radius: 50%;
				background: #ccc;
			}

			.icon {
				font-size: 20px;
				color: #fff;
			}
		}

		.btn-box {
			padding-top: 20px;
		}

		.session-title {
			display: inline-block;
			width: 100px;
			text-align: right;
			margin: 20px 10px 20px 0;

			&.type1 {
				margin-top: 0
			}
		}

		.new-channel-wrap {
			.new-channel-label {
				font-weight: 600;
				color: #303133;
			}
			.new-channel-tag {
				margin-right: 8px;
				margin-bottom: 4px;
			}
		}
	}

	.box-card {
		min-height: 100%;
	}

	.rules {
		width: 200px;
		display: inline-block;
		text-align: right;
		color: #909399
	}

	.info-table {
		td {
			border-right: 1px #E4E7ED solid;
		}

		.el-image {
			width: 60px;
			height: 60px;
			margin-right: 5px;
		}
	}
</style>